export class Code{
    id : number ;
    code: string;
    description: string;
    actif: boolean;
    
    constructor(data:any) {
        Object.assign(this, data);
    }
}